"use strict";

import Immutable from 'immutable';
import {MigrationStatusValue} from '../lib/migrationUtils';

/**
 * @typedef {Object} MigrationStatusDTO
 * @property {?string} UserName
 * @property {?string} MigrationStatus
 * @property {?string} TermsAcceptedDateTime
 * @property {?string} LastModifiedDateTime
 * @property {?number} FailCount
 */

class MigrationStatus extends Immutable.Record({
    userName: null,
    migrationStatus: MigrationStatusValue.NOT_STARTED,
    termsAcceptedDateTime: null,
    lastModifiedDateTime: null,
    failCount: 0
}) {
    /**
     * @param {MigrationStatusDTO} dataTransferObject
     * @return {MigrationStatus}
     */
    fromDTO(dataTransferObject = {}) {
        const status = dataTransferObject.MigrationStatus || MigrationStatusValue.NOT_STARTED;

        return new MigrationStatus({
            ...this.toJS(),
            userName: typeof dataTransferObject.UserName !== 'undefined'
                ? dataTransferObject.UserName
                : this.userName,
            migrationStatus: status,
            termsAcceptedDateTime: typeof dataTransferObject.TermsAcceptedDateTime !== 'undefined'
                ? dataTransferObject.TermsAcceptedDateTime
                : this.termsAcceptedDateTime,
            lastModifiedDateTime: typeof dataTransferObject.LastModifiedDateTime !== 'undefined'
                ? dataTransferObject.LastModifiedDateTime
                : this.lastModifiedDateTime,
            failCount: typeof dataTransferObject.FailCount === 'number'
                ? dataTransferObject.FailCount
                : (parseInt(dataTransferObject.FailCount, 10) || 0)
        });
    }
}

export default MigrationStatus;
